import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';

import { history } from './store';

import { LayoutContainer, LoginContainer } from './containers';

import { NoMatch } from './components/no-match';

const AppRouter = () => {
  return (
    <div className="app">
      <Router history={history}>
        <Switch>
          <Route path={'/login'} exact component={LoginContainer} />
          <Route path={'/'} component={LayoutContainer} />

          <Route component={NoMatch} />
        </Switch>
      </Router>
    </div>
  );
};

export default AppRouter;
